
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11 17l2.308-10","stroke":"#989AB2","stroke-width":"1.5","stroke-linecap":"round"}}),_c('circle',{attrs:{"cx":"12","cy":"12","r":"9.25","stroke":"#989AB2","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M8 9l-2 3 2 3M16 15l2-3-2-3","stroke":"#989AB2","stroke-width":"1.5","stroke-linecap":"round"}})])
          )
        }
      }
    